import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
    Box,
    Typography,
    Grid,
    Button
} from '@mui/material';
import DashboardLayout from '../components/layout/DashboardLayout/DashboardLayout';
import DriverRegistrationForm from '../components/forms/DriverRegistrationForm';
import MotorcycleSelector from '../components/selector/MotorcycleSelector';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../stores';
import { Vehicle } from '../stores/VehicleStore';

const Drivers: React.FC = observer(() => {
    const navigate = useNavigate();
    const { driverStore, vehicleStore } = useStore();
    const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);

    useEffect(() => {
        driverStore.loadDrivers();
        vehicleStore.loadVehicles();
    }, [driverStore, vehicleStore]);

    const handleVehicleSelect = (vehicle: Vehicle | null) => {
        setSelectedVehicle(vehicle);
    };

    const handleDriverCreatedSuccess = () => {
        setSelectedVehicle(null);
        driverStore.loadDrivers();
        vehicleStore.loadVehicles();
    };

    return (
        <DashboardLayout>
            <Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Box>
                        <Typography variant="h4" fontWeight="500" mb={1}>
                            Crear Conductores
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            Crea un conductor para el sistema
                        </Typography>
                    </Box>
                    <Button
                        variant="contained"
                        startIcon={<ManageAccountsIcon />}
                        onClick={() => navigate('/drivers')}
                        sx={{
                            backgroundColor: '#1A1A1A',
                            color: 'white',
                            borderRadius: 1.5,
                            px: 3,
                            py: 1.5,
                            textTransform: 'none',
                            fontWeight: 500,
                            '&:hover': {
                                backgroundColor: '#333333',
                            },
                        }}
                    >
                        Gestionar Conductores
                    </Button>
                </Box>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6, lg: 7 }}>
                        <DriverRegistrationForm 
                            selectedVehicle={selectedVehicle}
                            onSuccess={handleDriverCreatedSuccess}
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 6, lg: 5 }}>
                        <MotorcycleSelector 
                            selectedVehicleId={selectedVehicle?.id || null}
                            onVehicleSelect={handleVehicleSelect}
                        />
                    </Grid>
                </Grid>
            </Box>
        </DashboardLayout >
    );
});

export default Drivers;
